import { BrandMark } from "../components/BrandMark";

interface HomeProps {
  senderUrl: string;
}

export function Home({ senderUrl }: HomeProps) {
  return (
    <section id="home" className="hero">
      <div className="hero-plane" aria-hidden>
        <img
          className="hero-plane-img"
          src="/images/mac-receiver-pairing.png"
          alt=""
          width={980}
          height={720}
          decoding="async"
          fetchPriority="high"
        />
        <div className="hero-plane-veil" />
      </div>
      <div className="hero-inner">
        <h1 className="hero-brand">
          <BrandMark size={56} className="hero-brand-mark" />
          PairBolt
        </h1>
        <p className="hero-tagline">Large files. Free. No cloud.</p>
        <p className="hero-lead">
          Send big folders directly to your computer over Turbo TCP — private
          peer-to-peer, never uploaded to our servers.
        </p>
        <div className="hero-actions">
          <a className="btn btn-primary" href={senderUrl}>
            Start a free transfer
          </a>
          <a className="btn btn-outline" href="#download">
            Get the receiver
          </a>
        </div>
      </div>
    </section>
  );
}
